module.exports = __webpack_public_path__ + "img/sandy-and-lou.9c03ecad.png";